window.casinoModule = window.casinoModule || {};
const repos = window.casinoModule.repos = window.casinoModule.repos || {};

repos.base = {
    headers: function (apiKey) {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'RequestVerificationToken': casinoModule.config.antiForgeryToken,
            'ApiKey': apiKey,
        }
    },
    credentials: 'include',
    serializeGetParams: function (obj) {
        return '?' + Object.keys(obj).reduce(function (a, k) {
            a.push(k + '=' + encodeURIComponent(obj[k]));
            return a
        }, []).join('&')
    },
    checkResponse: function (response) {
        if (response.status !== 200) {
            throw response;
        }
        return response;
    },
    handleNetworkException: function (error) {
        if (casinoModule.repos.base.networkErrorsListener != null)
            casinoModule.repos.base.networkErrorsListener();
    },
    networkErrorsListener: null,
};

